import { Grid2} from '@mui/material';
import React, { useState } from 'react';
import BlastocystSegmentation from './BlastocystSegmentation';
import EmbryoInformationDetails from './EmbryoInformationDetails';
import EmbryoInfoDetailsLayout from './EmbryoInfoDetailsLayout';
import DevlopmentAnotation from './DevlopmentAnotation';
import EditEmbryoInformationModal from './EditEmbryoInformationModal/EditEmbryoInformationModal';
import { Embryo, EmbryoEditValues, fetchEmbryoResult, updateEmbryoGrade, UpdateEmbryoGradePayload } from './EmbryoGradingAi.helper';
import { useGradingHistory } from './GradingHistoryContext';
import { useTranslation } from 'react-i18next';
import { useAlert } from '../../components/alertProvider';

const EmbryoDetailsLayout: React.FC = () => {
  
  const { t: tAiGrading } = useTranslation('aiGrading_config');

  const [editModalOpen, setEditModalOpen] = useState(false);

  const { isGradingHistoryOpen , selectedEmbryoResult , selectedPatientForGrading , setSelectedEmbryoResult , selectedEmbryoForGrading } = useGradingHistory();


  const { addAlert } = useAlert();



  const getEmbryoResult = (data: Embryo) => {
    fetchEmbryoResult(data, setSelectedEmbryoResult, addAlert , tAiGrading);
  };

  const handleUpdateSelectedGradingHistory = (values: EmbryoEditValues) => {
    

    const historyId = String(selectedPatientForGrading?.patient_history_id);

    const payload: UpdateEmbryoGradePayload = {
      embryo_id: values.embryoId,
      grade_label: values.grade,
      icm_label: values.icmGrade,
      te_label: values.teGrade,
    };

    updateEmbryoGrade(historyId, payload)
      .then(() => {
        // get result after update
        addAlert(tAiGrading('SuccessUpdateEmbryoGrade'), 'success');
        if(selectedEmbryoForGrading){
          getEmbryoResult(selectedEmbryoForGrading);
        }      
      })
      .catch(() => {
        addAlert(tAiGrading('failedToUpdateEmbryoGrade'), 'error');
      });
  };


  const detailsBoxSx = {
    overflow: 'auto',
    display: isGradingHistoryOpen ? 'block' : 'flex',
  };

  const imageBoxSX = { 
    gap: 2, 
    mt: isGradingHistoryOpen ? 2 : 0 , 
    display: 'flex' , 
    alignItems: isGradingHistoryOpen ? 'stretch' : 'center', 
    flexDirection: isGradingHistoryOpen ? 'row' :  'column' 
  };

  return (
    <>     

      <Grid2 display="flex" gap={1}  flexDirection="column" size={12} height={'100%'} >
        <Grid2 container pl={0.5} size={12} height={'calc(100vh - 355px)'} sx={detailsBoxSx}>

          <Grid2 size={ isGradingHistoryOpen ? 12 : 8.5} minHeight={'100%'} pl={1} pr={2} display={'flex'} flexDirection="column" >       
            <Grid2 mb={2} width={'100%'}>
              <EmbryoInformationDetails
                score={selectedEmbryoResult?.EmbryoInformationDetails.aiViabilityScore}
                scoreLabel={tAiGrading('aiViabilitySuccessScore')}
                grades={{
                  grade: selectedEmbryoResult?.EmbryoInformationDetails.grade, 
                  icm: selectedEmbryoResult?.EmbryoInformationDetails.icmGrade,
                  te: selectedEmbryoResult?.EmbryoInformationDetails.teGrade,
                  embryoId: selectedEmbryoResult?.EmbryoInformationDetails.embryoId
                }}
                onEdit={() => setEditModalOpen(true)}
              />

              <EditEmbryoInformationModal
                open={editModalOpen}
                onClose={() => setEditModalOpen(false)}
                onSave={handleUpdateSelectedGradingHistory}
                initialValues={selectedEmbryoResult?.EmbryoInformationDetails}
              />


            </Grid2>


            <Grid2 width={'100%'} flex={1} display="flex" flexDirection="column"  sx={{ gap: 2, height: '100%' }}>
              <Grid2 width={'100%'}  sx={{ flex: 1, display: 'flex' }} >
                <EmbryoInfoDetailsLayout/>      
              </Grid2>
                
            
              <Grid2 width={'100%'} sx={{ flex: 1, display: 'flex' }} >
                <DevlopmentAnotation/>
              </Grid2>
            </Grid2>


          </Grid2>

          <Grid2 size={ isGradingHistoryOpen ? 12 : 3.5} sx={imageBoxSX}>
            <Grid2 width={'100%'} sx={{ flex: 1, display: 'flex' }}>
              <BlastocystSegmentation
                imageUrl={selectedEmbryoResult?.icm_seg_path} 
                title={tAiGrading('segmentationMapOfBlastocyst')}
                showLegend={true}
                width="100%"
                height="100%"
              />
            </Grid2>
            <Grid2 width={'100%'} sx={{ flex: 1, display: 'flex' }}>
              <BlastocystSegmentation
                imageUrl={selectedEmbryoResult?.te_cell_segms_img_path} 
                title={tAiGrading('teCellsCount')}
                showLegend={false}
                width="100%"
                height="100%"
              />
            </Grid2>
          </Grid2>

        </Grid2>
      </Grid2>
    </>
  );
};
  
export default EmbryoDetailsLayout;